import styled from 'styled-components';
import { BLUE } from '../../constants';

export const GameContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

export const BoardContainer = styled.div`
  background: #999;
  border: 10px outset #ccc;
`;

export const BoardContainerGrid = styled.ul`
  display: grid;
  background-color: #ddd;
  margin: 0;
  padding: 0;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  list-style-type: none;
`;

const BoardGridSquare = styled.li`
  background-color: #999;
  margin: 6px;
  padding: 0;
  padding-top: 3px;
  padding-left: 3px;
  border: 8px inset #aaa;
  height: 115px;
  width: 112px;
  position: relative;
`;

export const BoardGridTray = styled(BoardGridSquare)`
  background-color: #333;
  height: 370px;
  position: relative;
  overflow: hidden;

  ${(props) =>
    props.team === BLUE
      ? `grid-row: 2 / 5;`
      : `grid-column: 5 / 6; grid-row: 1 / 4;`}
`;
